/* High-Converting PDP — universal, pre-built behaviors (no per-product setup):
   1) Functional offer tiers  → update cart quantity / variant on selection
   2) Dynamic announcement bar → occasion by visitor's local date + country, TRANSLATED
   3) Locked review videos     → tap-to-pause only
   4) Urgency countdown        → to the visitor's LOCAL midnight
   5) Shipping line            → country FLAG emoji + country CODE (e.g. 🇸🇪 SE), from IP
   Markets: static text is translated via locale files (the `t` filter); this file
   translates only the JS-computed occasion labels. See references/shopify-theme.md.
*/
(function () {
  'use strict';
  function pad(n){ return String(n).padStart(2,'0'); }

  /* ---------------- i18n: generic sale labels ---------------- */
  // Seasons order: [Spring, Summer, Fall, Winter]. Reviewed by a native speaker recommended.
  var GEN = {
    en:{s:['Spring Sale','Summer Sale','Fall Sale','Winter Sale'],weekend:'Weekend Sale',newyear:'New Year Sale',valentine:"Valentine's Sale",halloween:'Halloween Sale',easter:'Easter Sale',christmas:'Christmas Sale'},
    nl:{s:['Lente Sale','Zomer Sale','Herfst Sale','Winter Sale'],weekend:'Weekend Sale',newyear:'Nieuwjaars Sale',valentine:'Valentijns Sale',halloween:'Halloween Sale',easter:'Paas Sale',christmas:'Kerst Sale'},
    de:{s:['Frühlings-Sale','Sommer-Sale','Herbst-Sale','Winter-Sale'],weekend:'Wochenend-Sale',newyear:'Neujahrs-Sale',valentine:'Valentins-Sale',halloween:'Halloween-Sale',easter:'Oster-Sale',christmas:'Weihnachts-Sale'},
    fr:{s:["Soldes de printemps","Soldes d'été","Soldes d'automne","Soldes d'hiver"],weekend:'Soldes du week-end',newyear:'Soldes du Nouvel An',valentine:'Soldes de la Saint-Valentin',halloween:"Soldes d'Halloween",easter:'Soldes de Pâques',christmas:'Soldes de Noël'},
    pl:{s:['Wiosenna wyprzedaż','Letnia wyprzedaż','Jesienna wyprzedaż','Zimowa wyprzedaż'],weekend:'Weekendowa wyprzedaż',newyear:'Noworoczna wyprzedaż',valentine:'Walentynkowa wyprzedaż',halloween:'Halloweenowa wyprzedaż',easter:'Wielkanocna wyprzedaż',christmas:'Świąteczna wyprzedaż'},
    it:{s:['Saldi di primavera','Saldi estivi','Saldi autunnali','Saldi invernali'],weekend:'Saldi del weekend',newyear:'Saldi di Capodanno',valentine:'Saldi di San Valentino',halloween:'Saldi di Halloween',easter:'Saldi di Pasqua',christmas:'Saldi di Natale'},
    es:{s:['Rebajas de primavera','Rebajas de verano','Rebajas de otoño','Rebajas de invierno'],weekend:'Rebajas de fin de semana',newyear:'Rebajas de Año Nuevo',valentine:'Rebajas de San Valentín',halloween:'Rebajas de Halloween',easter:'Rebajas de Pascua',christmas:'Rebajas de Navidad'},
    pt:{s:['Promoção de primavera','Promoção de verão','Promoção de outono','Promoção de inverno'],weekend:'Promoção de fim de semana',newyear:'Promoção de Ano Novo',valentine:'Promoção dos Namorados',halloween:'Promoção de Halloween',easter:'Promoção de Páscoa',christmas:'Promoção de Natal'},
    sv:{s:['Vårrea','Sommarrea','Höstrea','Vinterrea'],weekend:'Helgrea',newyear:'Nyårsrea',valentine:'Alla hjärtans-rea',halloween:'Halloweenrea',easter:'Påskrea',christmas:'Julrea'},
    nb:{s:['Vårsalg','Sommersalg','Høstsalg','Vintersalg'],weekend:'Helgesalg',newyear:'Nyttårssalg',valentine:'Valentinsalg',halloween:'Halloween-salg',easter:'Påskesalg',christmas:'Julesalg'},
    fi:{s:['Kevätale','Kesäale','Syysale','Talviale'],weekend:'Viikonloppuale',newyear:'Uudenvuoden ale',valentine:'Ystävänpäiväale',halloween:'Halloween-ale',easter:'Pääsiäisale',christmas:'Jouluale'}
  };
  function lang(){ var l=(document.documentElement.lang||navigator.language||'en').toLowerCase().slice(0,2); if(l==='no')l='nb'; return GEN[l]?l:'en'; }

  /* ---------------- date helpers ---------------- */
  var SH = ['AU','NZ','AR','CL','ZA','UY','PY','BO','PE','BR','NA','BW','ZW','MZ','MG','FJ'];
  function seasonIdx(m, cc){ var i=(m>=3&&m<=5)?0:(m>=6&&m<=8)?1:(m>=9&&m<=11)?2:3; return (cc&&SH.indexOf(cc.toUpperCase())!==-1)?(i+2)%4:i; }
  function nthDow(y,mon,dow,n){ var d=new Date(y,mon,1); var first=((dow-d.getDay()+7)%7)+1; return new Date(y,mon,first+(n-1)*7); }
  function dowInRange(y,mon,d1,d2,dow){ for(var d=d1; d<=d2; d++){ var x=new Date(y,mon,d); if(x.getDay()===dow) return x; } return new Date(y,mon,d1); }
  function easter(y){ var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,mm=Math.floor((a+11*h+22*l)/451),mon=Math.floor((h+l-7*mm+114)/31),day=((h+l-7*mm+114)%31)+1; return new Date(y,mon-1,day); }
  function bf(y){ var d=new Date(y,10,1); var f=1+((4-d.getDay()+7)%7); return new Date(y,10,f+21+1); } // Black Friday
  // is `now` within [date - lead, date]  (inclusive of the day)
  function win(now,date,lead){ var s=new Date(date); s.setDate(date.getDate()-(lead||4)); var e=new Date(date); e.setDate(date.getDate()+1); return now>=s && now<e; }
  function md(now,y,m,d,lead){ return win(now,new Date(y,m-1,d),lead); } // month is 1-12

  /* ---------------- country-specific national holidays (localized inline) ---------------- */
  // Each returns candidates {w, l}. w=50 for national/cultural. Shown only to that country.
  function countryHolidays(cc, now){
    var y=now.getFullYear(), out=[]; cc=(cc||'').toUpperCase(); var E=easter(y);
    function push(active,label){ if(active) out.push({w:50,l:label}); }
    // Good Friday / Easter Monday windows reuse E; national days below.
    switch(cc){
      case 'US':
        push(md(now,y,7,4,4),'4th of July Sale');
        push(win(now,nthDow(y,4,1,4),4),'Memorial Day Sale');          // last Mon May ≈ 4th/5th; use 4th Mon as approx
        push(win(now,nthDow(y,8,1,1),4),'Labor Day Sale');             // 1st Mon Sep
        push(win(now,nthDow(y,1,1,3),3),"Presidents' Day Sale");       // 3rd Mon Feb
        push(md(now,y,3,17,3),"St. Patrick's Day Sale"); break;
      case 'CA':
        push(md(now,y,7,1,4),'Canada Day Sale');
        push(win(now,nthDow(y,9,1,2),4),'Thanksgiving Sale');          // 2nd Mon Oct
        push(md(now,y,12,26,2),'Boxing Day Sale');
        push(win(now,dowInRange(y,4,18,24,1),4),'Victoria Day Sale'); break; // Mon before May 25
      case 'NL':
        push(md(now,y,4,27,4),'Koningsdag Sale');
        push(md(now,y,12,5,4),'Sinterklaas Sale'); break;
      case 'DE':
        push(md(now,y,10,3,4),'Sale zum Tag der Einheit');
        push(md(now,y,12,6,3),'Nikolaus-Sale'); break;
      case 'AT':
        push(md(now,y,10,26,4),'Nationalfeiertag-Sale');
        push(md(now,y,12,6,3),'Nikolaus-Sale'); break;
      case 'CH':
        push(md(now,y,8,1,4),'Nationalfeiertag-Sale'); break;
      case 'FR':
        push(md(now,y,7,14,4),'Soldes du 14 juillet'); break;
      case 'PL':
        push(md(now,y,5,3,4),'Wyprzedaż na 3 Maja');
        push(md(now,y,11,11,4),'Wyprzedaż Niepodległości'); break;
      case 'IT':
        push(md(now,y,6,2,4),'Saldi della Repubblica');
        push(md(now,y,8,15,4),'Saldi di Ferragosto');
        push(md(now,y,1,6,3),"Saldi dell'Epifania"); break;
      case 'ES':
        push(md(now,y,10,12,4),'Rebajas del Día de la Hispanidad');
        push(md(now,y,1,6,3),'Rebajas de Reyes'); break;
      case 'PT':
        push(md(now,y,6,10,4),'Promoção do Dia de Portugal'); break;
      case 'SE':
        push(md(now,y,6,6,4),'Nationaldagsrea');
        push(win(now,dowInRange(y,5,19,25,5),3),'Midsommarrea');       // Fri Jun 19-25
        push(md(now,y,12,13,3),'Luciarea'); break;
      case 'NO':
        push(md(now,y,5,17,4),'17. mai-salg'); break;
      case 'FI':
        push(md(now,y,12,6,4),'Itsenäisyyspäivän ale');
        push(win(now,dowInRange(y,5,20,26,6),3),'Juhannusale'); break; // Sat Jun 20-26
      case 'AU':
        push(md(now,y,1,26,4),'Australia Day Sale');
        push(md(now,y,4,25,4),'ANZAC Day Sale');
        push(md(now,y,12,26,2),'Boxing Day Sale'); break;
      case 'NZ':
        push(md(now,y,2,6,4),'Waitangi Day Sale');
        push(md(now,y,4,25,4),'ANZAC Day Sale');
        push(md(now,y,12,26,2),'Boxing Day Sale'); break;
    }
    return out;
  }

  /* ---------------- occasion picker ---------------- */
  function occasion(now, cc){
    var g=GEN[lang()], y=now.getFullYear(), m=now.getMonth()+1, d=now.getDate(), w=now.getDay(), E=easter(y), c=[];
    c.push({w:10,l:g.s[seasonIdx(m,cc)]});                       // season (floor)
    if(w===0||w===6) c.push({w:30,l:g.weekend});                // weekend
    // generic cultural/commercial holidays (translated)
    if(md(now,y,1,1,1)||md(now,y,12,31,0)) c.push({w:50,l:g.newyear});
    if(md(now,y,2,14,6)) c.push({w:40,l:g.valentine});
    if(md(now,y,10,31,7)) c.push({w:40,l:g.halloween});
    if(win(now,E,5)) c.push({w:50,l:g.easter});                 // Good Friday..Easter Sunday
    if(md(now,y,12,25,10)) c.push({w:50,l:g.christmas});
    // country national days (already localized)
    countryHolidays(cc, now).forEach(function(h){ c.push(h); });
    // Black Friday / Cyber Monday — top priority (kept in English, globally used)
    var B=bf(y), CM=new Date(B.getFullYear(),B.getMonth(),B.getDate()+3);
    if(now.getFullYear()===CM.getFullYear()&&now.getMonth()===CM.getMonth()&&now.getDate()===CM.getDate()) c.push({w:100,l:'Cyber Monday Sale'});
    else if(now>=new Date(B.getFullYear(),B.getMonth(),B.getDate()) && now<CM) c.push({w:100,l:'Black Friday Sale'});
    c.sort(function(a,b){return b.w-a.w;});
    return c[0].l;
  }
  function renderAnnouncement(cc){
    var el=document.querySelector('.pdp-announcement[data-dynamic="true"]'); if(!el) return;
    if(el.getAttribute('data-override')) return;
    var offer=el.getAttribute('data-offer')||'';
    el.innerHTML=occasion(new Date(),cc)+(offer?': <b>'+offer+'</b>':'');
  }
  function flagEmoji(cc){ if(!cc||cc.length!==2) return ''; return String.fromCodePoint.apply(null, cc.toUpperCase().split('').map(function(c){return 127397+c.charCodeAt(0);})); }

  /* ---------------- variant swatches (color/size) ---------------- */
  function wireVariants(){
    var form=document.getElementById('pdp-form'); if(!form) return;
    var dataEl=document.querySelector('.pdp-variants-data'); var ui=document.querySelector('.pdp-variants-ui');
    if(!dataEl||!ui) return;
    var variants; try{ variants=JSON.parse(dataEl.textContent); }catch(e){ return; }
    var idInput=form.querySelector('input[name="id"]');
    var sel=[];
    ui.querySelectorAll('.swatch--on').forEach(function(b){ sel[+b.getAttribute('data-opt')]=b.getAttribute('data-val'); });
    function apply(){
      var v=variants.find(function(x){ return (x.options||[]).every(function(o,i){ return String(o)===String(sel[i]); }); });
      if(v){ window.__pdpBaseVariant=v.id; if(idInput) idInput.value=v.id;
        // re-apply the selected tier so quantity + any tier-variant override still flow through
        var ct=form.querySelector('.tier input[type="radio"]:checked'); if(ct) ct.dispatchEvent(new Event('change'));
      }
    }
    ui.querySelectorAll('.swatch').forEach(function(b){
      b.addEventListener('click', function(){
        var oi=+b.getAttribute('data-opt');
        ui.querySelectorAll('.swatch[data-opt="'+oi+'"]').forEach(function(x){ x.classList.remove('swatch--on'); });
        b.classList.add('swatch--on'); sel[oi]=b.getAttribute('data-val');
        var lbl=ui.querySelector('.opt-selected[data-opt="'+oi+'"]'); if(lbl) lbl.textContent=sel[oi];
        apply();
      });
    });
    apply();
  }

  /* ---------------- functional offer tiers ---------------- */
  function wireTiers(){
    var form=document.getElementById('pdp-form'); if(!form) return;
    var idInput=form.querySelector('input[name="id"]');
    var qtyInput=form.querySelector('input[name="quantity"]');
    var defaultId=idInput ? idInput.value : null;
    form.querySelectorAll('.tier input[type="radio"]').forEach(function(r){
      r.addEventListener('change', function(){
        var t=r.closest('.tier'); if(!t) return;
        // highlight follows :checked via CSS :has() — no class juggling needed
        if(qtyInput) qtyInput.value = t.getAttribute('data-qty') || '1';
        // tier's own variant wins; else the swatch-selected base variant; else the default
        var tv=t.getAttribute('data-variant');
        if(idInput) idInput.value = tv || window.__pdpBaseVariant || defaultId;
      });
    });
    var checked=form.querySelector('.tier input[type="radio"]:checked'); // apply preselected tier now
    if(checked) checked.dispatchEvent(new Event('change'));
  }

  /* ---------------- per-unit bundle variant pickers (#1 #2 #3) ---------------- */
  function wireUnitSwatches(){
    function paintPick(pick, btn, alsoHero){
      if (!btn) return;
      var nm  = pick.querySelector('.tier-pick__nm');
      var pv  = pick.querySelector('.tier-pick__prev');
      var img = btn.getAttribute('data-img');
      if (nm) nm.textContent = btn.getAttribute('data-name') || '';
      if (pv) {
        if (img) { pv.src = img; pv.style.display = 'block'; }
        else { pv.removeAttribute('src'); pv.style.display = 'none'; }
      }
      // swap the main gallery image to the design that was just picked
      if (alsoHero && img) {
        var hero = document.querySelector('.pdp-buy .pdp-hero');
        if (hero) hero.src = img;
      }
    }
    document.querySelectorAll('.pdp-buy .tier-pick').forEach(function(pick){
      // show whatever is preselected before the shopper touches anything
      paintPick(pick, pick.querySelector('.uswatch--on') || pick.querySelector('.uswatch'), false);
      pick.querySelectorAll('.uswatch').forEach(function(b){
        b.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();               // don't toggle the tier radio
          pick.querySelectorAll('.uswatch').forEach(function(x){ x.classList.remove('uswatch--on'); });
          b.classList.add('uswatch--on');
          paintPick(pick, b, true);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    renderAnnouncement(null);
    wireVariants();
    wireTiers();
    wireUnitSwatches();
    document.querySelectorAll('.review-vid').forEach(function(v){ v.style.cursor='pointer'; v.addEventListener('click',function(){ v.paused?v.play():v.pause(); }); });
    document.querySelectorAll('.pdp-countdown').forEach(function(el){ (function tick(){ var now=new Date(); var mid=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,0,0,0,0); var s=Math.max(0,Math.floor((mid-now)/1000)); el.textContent=pad(s/3600|0)+':'+pad(s/60%60|0)+':'+pad(s%60); setTimeout(tick,1000); })(); });
    fetch('https://ipapi.co/json/').then(function(r){return r.json();}).then(function(d){ if(!d) return;
      var n=document.getElementById('ship-country'), f=document.getElementById('ship-flag');
      if(n&&d.country_code) n.textContent=d.country_code;
      if(f&&d.country_code) f.textContent=flagEmoji(d.country_code);
      renderAnnouncement(d.country_code);
    }).catch(function(){});
  });
})();
